import React, {useEffect, useState} from 'react';
import { useParams,Redirect } from 'react-router-dom';
import ClassInfo from '../components/ClassInfo';
import ClassRecommendations from '../../shared/components/UIElements/ClassRecommendations';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import Button from '../../shared/components/Form/Button';

import './ViewClass.css';

const ViewClass = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadedClass, setLoadedClass]= useState();
  const [error, setError]= useState();
  const classId = useParams().classId;
  useEffect(()=>{
    window.scrollTo(0, 0);
    const sendRequest = async() =>{
      try{
        setIsLoading(true);
        const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/classes/'+classId);
        if (await !response.ok){
          setError(response.statusText);
         }else{
        const responseData= await response.json();
        setLoadedClass(responseData);
        setIsLoading(false);
         }
      }catch(err){
        setError(err); 
      }
    };
    sendRequest();
  },[classId]);

  
const hideSameDatasetRecs = async (val) =>{
  try{
    setIsLoading(true);
    const response = await fetch(process.env.REACT_APP_BACKEND_API_URL+'/classes/'+classId+"/"+val);
    if (await !response.ok){
      setError(response.statusText);
     }else{
    const responseData= await response.json();
    setLoadedClass(responseData);
    setIsLoading(false);
     }
  }catch(err){
    setError(err); 
  }
}
  
  return (<div className="viewClassDiv">
    {error &&  <Redirect to="/" /> }
    {isLoading &&(<div className="center"><LoadingSpinner asOverlay/></div>)} 
    {!isLoading && loadedClass && <ClassInfo
      key={loadedClass.id}
      id={loadedClass.id}
      image={`${process.env.REACT_APP_BACKEND_URL}/static/thumbnails/classes/${loadedClass.id}.jpg`}
      title={loadedClass.label}
      description={loadedClass.description}
      uri={loadedClass.uri}
      numOfEntities={loadedClass.entities}
      numOfRecommendations={loadedClass.recommendations}
      ontology={loadedClass.ontology}
      ontology_uri={loadedClass.ontology_uri}
      dataset={loadedClass.dataset}
      datasetid={loadedClass.datasetid}
      />} 
    
    {!isLoading && loadedClass && <ClassRecommendations recs={loadedClass.recs} format="endpoint" dataset={loadedClass.url} cs={loadedClass.uri} ontology={loadedClass.ontology}/>}
 
     <div className="bottomRecsPanel">
      <div className="leftBottomRecsPanel"><input type="checkbox" id="hide"  onChange={(v)=>hideSameDatasetRecs(v.target.checked)}/>
        <label for="hide">&nbsp;Hide recommendations from same dataset</label></div>
        <div className="rightBottomRecsPanel">
        {!isLoading && loadedClass &&  <Button href={`${process.env.REACT_APP_BACKEND_API_URL}/download/classrecommendations/${loadedClass.id}`} target="new">Export Recommendations</Button>}
       </div></div>
    
</div>);
  };
  
  export default ViewClass;